import { render, staticRenderFns } from "./AddTemplate.vue?vue&type=template&id=1046da71&scoped=true&"
import script from "./AddTemplate.vue?vue&type=script&lang=js&"
export * from "./AddTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AddTemplate.vue?vue&type=style&index=0&id=1046da71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1046da71",
  null
  
)

export default component.exports